import React from "react";

import "./Term.scss";

export default function Term({ label }) {
  return <span className="term">{label}</span>;
}
